import type { Path } from 'react-router';
import { createPath } from 'react-router';

import { iots } from '@code-expert/prelude';
import { UiState } from '/imports/utils/UiState';

const lastLocationUiState = UiState.valueProp('lastLocation', iots.string);

export function pushLastLocation(path: Path): void {
  lastLocationUiState.set(createPath(path), '1h');
}

export function popLastLocation() {
  return lastLocationUiState.get();
}

export function popLastLocationOrDefault() {
  return popLastLocation() ?? '/';
}
